<template>
    <div class="searchMachine__result">
        <article class="mediaCard -shadow">
            <div class="mediaCard__inner">
                <div
                    class="mediaCard__media"
                    :style="{ backgroundColor: color }"
                >
                    <a
                        :href="result.permalink"
                        class="mediaCard__link"
                    >
                        <img
                            v-if="isArticle"
                            :src="result.image_thumbnail
                                ? result.image_thumbnail
                                : '/images/frontend/article-thumbnail-default.png'"
                            alt=""
                        >
                        <i
                            v-if="!isArticle"
                            class="mediaCard__icon fad"
                            :class="icon"
                        />
                    </a>
                </div>
                <!-- /.mediaCard__media -->
                <div class="mediaCard__content">
                    <div class="categoriesEyebrow">
                        <p
                            v-if="type"
                            class="categoriesEyebrow__type"
                            :style="{color}"
                            v-text="type"
                        />
                        <template v-if="result.department">
                            <span
                                v-if="showBullet"
                                class="categoriesEyebrow__separator"
                            >
                                &bull;
                            </span>
                            <p
                                class="categoriesEyebrow__department"
                                v-text="result.department"
                            />
                        </template>
                    </div>
                    <!-- /.categoriesEyebrow -->
                    <h2 class="mediaCard__heading">
                        <a
                            :href="this.result.permalink"
                            class="mediaCard__link"
                            v-text="result.title"
                        />
                    </h2>
                    <p
                        v-if="result.description"
                        class="mediaCard__copy"
                        v-text="result.description"
                    />
                </div>
                <!-- /.mediaCard__content -->
                <favorite-action
                    v-if="isResource"
                    class="mediaCard__save saveIcon"
                    :is-favorite="result.is_saved"
                    :item-id="result.id"
                    item-type="resource"
                />
                <like-action
                    v-if="isArticle"
                    class="mediaCard__save saveIcon"
                    :is-liked="result.is_saved"
                    :item-id="result.id"
                />
            </div>
            <!-- /.mediaCard__inner -->
        </article>
    </div>
    <!-- /.searchMachine__result -->
</template>

<script>
import FavoriteAction from '../FavoriteAction.vue';
import LikeAction from '../LikeAction.vue';

export default {
    name: 'ResultsCard',
    components: {
        FavoriteAction,
        LikeAction,
    },
    props: {
        result: {
            type: Object,
            required: true,
        },
    },
    computed: {
        isResource() {
            return this.result.content_type === 'Resource';
        },
        isArticle() {
            return this.result.content_type === 'Article';
        },
        isPage() {
            return this.result.content_type === 'Page';
        },
        color() {
            if (this.isResource) {
                return this.result.color;
            }

            if (this.isArticle) {
                return this.result.color;
            }

            if (this.isPage) {
                return '#7F0FC5';
            }

            return '#3c82c3';
        },
        type() {
            if (this.isResource) {
                return this.result.type;
            }

            if (this.isArticle) {
                return this.result.type;
            }

            return false;
        },
        showBullet() {
            return this.type && this.result.department;
        },
        icon() {
            if (this.isResource) {
                return 'fa-file-alt';
            }

            if (this.isPage) {
                return 'fa-window';
            }

            return 'fa-file-alt';
        },
    },
};
</script>
